module.exports = __webpack_public_path__ + "img/o.ebe393bf.svg";